import axios from "axios";
import { authHeader } from "./headerConfig";
const API_ENDPOINT =
  process.env.REACT_APP_ENDPOINT + "/api/x-admin/popup-messages";

const addPupupMessage = (data) => {
  return axios.post(API_ENDPOINT, data, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
};

const editPupupMessage = (data, id) => {
  return axios.put(`${API_ENDPOINT}/${id}`, data, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
};
const getAllPupupMessage = async (page = 1) => {
  const response = await axios.get(`${API_ENDPOINT}?page=${page}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });

  return response.data;
};
const deletePupupMessage = (id) => {
  return axios.delete(`${API_ENDPOINT}/${id}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
};
const getPupupMessage = async (id) => {
  const response = await axios.get(`${API_ENDPOINT}/${id}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
  return response.data;
};
const popupServices = {
  addPupupMessage,
  editPupupMessage,
  getAllPupupMessage,
  deletePupupMessage,
  getPupupMessage,
};

export default popupServices;
